// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");

function arg(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* XLarge */5, /* Bold */2);
}

var title = Curry._1(BrowserStyle.style, Curry._1(arg(undefined), /* [] */0));

var Styles = {
  title: title
};

function WebComponents_SettingsHeader(Props) {
  var title$1 = Props.title;
  return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Text.make, {
                  className: title,
                  children: title$1
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* XLarge */6
                }));
}

var make = WebComponents_SettingsHeader;

exports.Styles = Styles;
exports.make = make;
/* title Not a pure module */
